module.exports = __webpack_public_path__ + "img/home-rbn-4.987335a8.png";